import React from 'react'
import { Link } from 'react-router-dom'

function AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview() {
    return ( 
            <div> <div>
                <h1>Análisis de funcionamiento del Trust Anchor (TA) de RPKI v1</h1>
                <p>Autor: ERIKA VEGA - CHAIR GRUPO DE TRABAJO ENRUTAMIENTO LACNOG</p>

                <p>Coordinación: GUILLERMO CICILEO (LIDER DE I+D LACNIC)</p>

                <p>Área: I+D EN INFRAESTRUCUTURA DE INTERNET</p>

                <p>Fecha: 01/11/2025</p>
                <Link className="buttons button_blue" to="/es/interconexion/analisis-de-funcionamiento-del-trust-anchor-ta-de-rpki-v1">Leer Reporte</Link>
            </div> </div>
    )
}

export default AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview
